import React, { useState, useMemo } from "react";
import { MdExpandMore } from "react-icons/md";
import ColorPicker from "./ColorPicker";
import RangeSlider from "./RangeSlider";

const ThemeSection = ({
  title,
  icon,
  sectionKey,
  properties,
  themeValues,
  onThemeChange,
  defaultExpanded = false,
  searchTerm = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const entries = Object.entries(properties);

  // Arama: label içinde geçen ayarları filtrele
  const filtered = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return entries;
    return entries.filter(([, cfg]) => (cfg.label || "").toLowerCase().includes(q));
  }, [entries, searchTerm]);

  // Arama varsa ve eşleşme yoksa bölümü gizle
  if (searchTerm && filtered.length === 0) return null;

  // Arama yapılıyorsa otomatik aç
  const expanded = isExpanded || !!searchTerm;

  return (
    <div className={`css-section${expanded ? " expanded" : ""}`}>
      <div className="section-header" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="section-header-left">
          {icon && <div className="section-icon-wrap">{icon}</div>}
          <h3>
            {title}
            <span className="section-count">{filtered.length}</span>
          </h3>
        </div>
        <MdExpandMore size={20} className="section-chevron" />
      </div>

      {expanded && (
        <div className="section-content">
          {filtered.map(([propertyKey, config]) => {
            const themeKey = `${sectionKey}_${propertyKey}`;
            const currentValue = themeValues[themeKey];

            if (config.type === "range") {
              return (
                <RangeSlider
                  key={themeKey}
                  label={config.label}
                  value={currentValue}
                  onChange={(value) => onThemeChange(themeKey, value)}
                  min={config.min !== undefined ? config.min : 0}
                  max={config.max !== undefined ? config.max : 100}
                  step={config.step !== undefined ? config.step : 1}
                  unit={config.unit || ""}
                />
              );
            }
            if (config.type === "boolean") {
              const isTrue = currentValue === "true" || currentValue === true;
              return (
                <div
                  key={themeKey}
                  className="bg-toggle-row"
                  onClick={() => onThemeChange(themeKey, !isTrue ? "true" : "false")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "8px",
                    marginBottom: "8px",
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                >
                  <span className="bg-toggle-label">{config.label}</span>
                  <div className={`bg-toggle-switch${isTrue ? ' on' : ''}`}>
                    <div className="bg-toggle-knob" />
                  </div>
                </div>
              );
            }
            return (
              <ColorPicker
                key={themeKey}
                label={config.label}
                value={currentValue}
                onChange={(color) => onThemeChange(themeKey, color)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ThemeSection;
